import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(false)
  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    setIsClient(true)
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const initialMobile = window.innerWidth < MOBILE_BREAKPOINT
    setIsMobile(initialMobile)
    
    const onChange = () => {
      const newMobile = window.innerWidth < MOBILE_BREAKPOINT
      setIsMobile(newMobile)
    }
    mql.addEventListener("change", onChange)
    // Redundant setIsMobile removed - initial state already set above
    return () => mql.removeEventListener("change", onChange)
  }, [])

  // Prevent hydration mismatches by returning false until client-side
  return isClient ? isMobile : false
}
